// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { Store } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from 'Store';

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// Typed store accessor for reading the latest state imperatively (e.g. at send time).
export const useAppStore: () => Store<RootState> = useStore;
